import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Intro from './views/Intro.vue'
import Questions from './views/Questions.vue'
import Finish from './views/Finish.vue'
import Root from './views/Root.vue'
import Intervoice from '@/components/Intervoice/Intervoice'

import SetToken from './middlewares/SetToken'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/conversation/:token',
      name: 'meet',
      component: Intervoice
    },
    {
      path: '/',
      name: 'root',
      component: Root
    }, {
      path: '/:token',
      name: 'home',
      component: Home,
      beforeEnter: SetToken,
      children: [
        /* questions */
        {
          path: '',
          name: 'intro',
          component: Intro
        },
        /* questions */
        {
          path: 'questions',
          name: 'questions',
          component: Questions
        },
        /* finish */
        {
          path: 'finish',
          name: 'finish',
          component: Finish
        }
      ]
    }
  ]
})
